<template>

  <div class="img-container" @click="goLink">
    <img-v3 :src="formItem.img_url" />
    <div class="img-text">
        <h1>{{formItem.title}}</h1>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";
import '../../tools/onelink-smart-script';
export default {
  props: ["formItem", "idx"],
  methods: {
    goLink() {
      let url = this.formItem.link;
      if (!url) return

      let up = new URLSearchParams(location.search);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this._area && this._area.value) {
        up.set("areaId", this._area.value);
      }
      if (this._area && this._area.text) {
        up.set("areaName", this._area.text);
      }
      console.log(this._area,999)
      if (url.indexOf("?") > -1) {
        url = `${url}&${up}`;
      } else {
        url = `${url}?${up}`;
      }
      console.log(url)
      if (ends.inApp) {
        Fusion.openPage && Fusion.openPage({
          url: url,
          newWindow: true,
        });
      } else {
        window.open(url)
      }
    },

  },
  computed: {
    ...mapState(["_ticket","_area"])
  }
};
</script>
<style lang="scss" scoped>
.img-container {
    position: relative;
    width: 100%;
    // height: 1.68rem;
    margin: 0.32rem 0;
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
		>img {
			max-width: 100%;
		}
    .img-text {
      position: absolute;
      width: 70%;
      color: #ffffff;
      font-style: italic;
      font-weight: 600;
      font-size: .32rem;
      line-height: .36rem;
			z-index: 10;
      P {
        padding-bottom: .08rem;
        font-weight: bold;
        font-size: .2rem;
      }
      h1 {
        font-weight: inherit;
        font-size: inherit;
        line-height: inherit;
      }
      // z-index: 2;
    }
  }
</style>

